import Vue from 'vue';
import * as types from '@/store/mutationTypes';
import API from '@/api';
import { getField } from 'vuex-map-fields';
import { get } from 'lodash';
import * as Companies from '@/types/models/company';

const state = {
  loadingProfile: false,
  loadingCompanies: false,
  companies: [],
  catalog: [],
  company: {},
  profileCompany: {
    companyAddress: {},
    producerInfo: {
      billingAddress: {},
    },
    truckingInfo: {
      insurancePolicyCertificate: {
        agent: {},
      },
    },
  },
};

const getters = {
  getField,
  loadingCompanies: companyState => companyState.loadingCompanies,
  currentCompany: companyState => companyState.company,
  companies: companyState => companyState.companies,
  catalog: (companyState) => {
    return companyState.catalog.map((company) => {
      // eslint-disable-next-line no-param-reassign
      company.searchName = company.companyName;
      if (get(company, 'companyAddress.city', false) &&
        get(company, 'companyAddress.region', false)) {
        // eslint-disable-next-line no-param-reassign
        company.searchName += ` (${company.companyAddress.city}, ${company.companyAddress.region})`;
      }

      return company;
    });
  },
  allTruckingCompanies: (companyState, gets) =>
    gets.catalog.filter(company => company.truckingInfo),
  // TODO: this does NOT update listening computed attributes when companies is committed. mixin?
  truckingCompanies: (companyState) => {
    return companyState.companies.filter(company => company.truckingInfo);
  },
};

const mutations = {
  [types.UPDATE_COMPANIES_LOADING](companyState, loading) {
    // eslint-disable-next-line no-param-reassign
    companyState.loadingCompanies = loading;
  },
  [types.UPDATE_PROFILE_COMPANY_LOADING](companyState, loading) {
    // eslint-disable-next-line no-param-reassign
    companyState.loadingProfile = loading;
  },
  [types.SET_COMPANIES](companyState, companies) {
    // eslint-disable-next-line no-param-reassign
    companyState.companies = companies;
  },
  [types.SET_PROFILE_COMPANY](companyState, company) {
    /* eslint-disable no-param-reassign */
    company.companyAddress = get(company, 'companyAddress', {}) || {};
    company.producerInfo = get(company, 'producerInfo', {}) || {};
    company.producerInfo.billingAddress = get(company, 'producerInfo.billingAddress', {}) || {};

    company.truckingInfo = get(company, 'truckingInfo', {}) || {};
    company.truckingInfo.insurancePolicyCertificate = get(company, 'truckingInfo.insurancePolicyCertificate', {}) || {};
    company.truckingInfo.insurancePolicyCertificate.agent = get(company, 'truckingInfo.insurancePolicyCertificate.agent', {});
    companyState.profileCompany = company;
    /* eslint-enable no-param-reassign */
  },
  [types.SET_COMPANY](companyState, company) {
    /* eslint-disable no-param-reassign */
    companyState.company = company;
    /* eslint-enable no-param-reassign */
  },
  [types.CLEAR_COMPANIES_MODULE](companyState) {
    /* eslint-disable no-param-reassign */
    companyState.company = {};
    companyState.profileCompany = {};
    companyState.companies = [];
    /* eslint-enable no-param-reassign */
  },
  [types.SET_ALL_COMPANIES](companyState, allCompanies) {
    // eslint-disable-next-line no-param-reassign
    companyState.catalog = allCompanies;
  },
  updateField(funcState, { path, value }) {
    path.split(/[.[\]]+/).reduce((prev, key, index, array) => {
      if (array.length === index + 1) {
        // eslint-disable-next-line no-param-reassign
        Vue.set(prev, key, value);
      }
      return prev[key];
    }, funcState);
  },
};

const actions = {
  clear({ commit }) {
    commit(types.CLEAR_COMPANIES_MODULE);
  },
  async getCompanies({ commit }) {
    const response = await API.company.all();
    commit(types.SET_COMPANIES, response.data.companies);
  },
  async getCompany({ commit }, params) {
    const response = await API.company.byId(params);
    commit(types.SET_COMPANY, response.data);
  },
  async getProfileCompany({ commit }, params) {
    commit(types.UPDATE_PROFILE_COMPANY_LOADING, true);
    const response = await API.company.byId(params);
    commit(types.SET_PROFILE_COMPANY, response.data);
    commit(types.UPDATE_PROFILE_COMPANY_LOADING, false);
  },
  async getAllCompanies({ commit }) { // V2 company API. Same object, no permissions scrub
    commit(types.UPDATE_COMPANIES_LOADING, true);
    const response = await API.company.catalog();
    commit(types.SET_ALL_COMPANIES, response.data.companies);
    commit(types.UPDATE_COMPANIES_LOADING, false);
  },
  async removeLocation({ commit }, params) {
    const loadingLocations = Companies.loadingChutes(state.company);
    const locationsList = loadingLocations.slice(0, loadingLocations.length);
    locationsList.splice(params.locationIndex, 1);

    const response = await API.company.editLoadingInfo({
      companyId: state.company.id,
      body: { locations: locationsList } });

    commit(types.SET_PROFILE_COMPANY, response.data);
  },
  async addLocation({ commit }, location) {
    const loadingLocations = Companies.loadingChutes(state.company);

    const locationsList = loadingLocations.slice(0, loadingLocations.length);
    locationsList.push(location);

    const response = await API.company.editLoadingInfo({
      companyId: state.company.id,
      body: { locations: locationsList } });

    commit(types.SET_PROFILE_COMPANY, response.data);
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
  namespaced: true,
};



// WEBPACK FOOTER //
// ./src/store/modules/companies.js